export default __webpack_public_path__ + "static/media/comercio_6.399385fa.png";